module.exports = "/images/default-company-logo.png?1ffd83cfcab97aeb3b49fe7fe3dfd35e";